import { render, staticRenderFns } from "./AmortizableDetail.vue?vue&type=template&id=06566960&scoped=true"
import script from "./AmortizableDetail.vue?vue&type=script&lang=js"
export * from "./AmortizableDetail.vue?vue&type=script&lang=js"
import style0 from "./AmortizableDetail.vue?vue&type=style&index=0&id=06566960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06566960",
  null
  
)

export default component.exports